"use strict";

exports.__esModule = true;
exports.Box = void 0;

var _styled = require("@manifest-ui/styled");

const Box = (0, _styled.styled)('div', {
  label: 'Box',
  themeKey: 'box'
})({
  boxSizing: 'border-box',
  margin: 0,
  minWidth: 0
});
exports.Box = Box;
Box.displayName = 'Box';